import { ComplexTable } from '@synergy/table';
import { Checkbox, Col, DatePicker, Divider, Input, notification, Row, Segmented, Select, Tag } from 'antd';
import clsx from 'clsx';
import dayjs from 'dayjs';
import i18next from "i18next";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../../contexts/AuthContext';
import query from '../../../../server/constants.api';
import useFetch from "../../../../server/useFetch";
import { PageContent, PageSection, PageTitle } from "../../../../styles/global/Pages.styled";
import { booleans, period, periodicity, privacy } from '../../../../utils/config/widgetsConfig';
import { MultipleSelectAtomic } from '../../Atomics/MultipleSelectAtomic';
import Spinner from '../../Atomics/Spinner';
import { Text } from '../../Atomics/Text';
import permissionToEdit from './AccessUtils';
import { buildObj, getCustomizedButtonsForConfiguration } from './ConfigurationUtils';
import { EditPopupConfigurations } from './EditPopupConfigurations';

export const WidgetConfigurations = ({ ...props }) => {
    const { tenant } = useAuthContext();
    // Obtém a função de tradução do hook useTranslation para uso na tradução de textos
    const allowedToWrite = permissionToEdit(['Configurations', 'WidgetConfigurations'])
    const { t, i18n } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isTofecth, setIsToFetch] = useState(false);
    const [bodyToPost, setBodyToPost] = useState(null);

    const [idToDelete, setIdToDelete] = useState(null);
    const [isToFetchDelete, setIsToFetchDelete] = useState(false);

    const [buildingType, setBuildingType] = useState(null);
    const [fetchClasses, setFetchClasses] = useState(false);

    const [selectedPeriodicity, setSelectedPeriodicity] = useState(null);

    const {
        data: buildingInformation
    } = useFetch("/configurations/building-classes", "buildingClasses", { tenant: tenant, type: buildingType }, fetchClasses, null, query.middlewareURL);

    useEffect(() => {
        setFetchClasses(false);
    }, [buildingInformation])

    const {
        data: configs
    } = useFetch("/configurations/widget/modal", "modalWidgetConfigs", { tenant: tenant }, null, null, query.middlewareURL);

    const {
        data: widgets,
        refetch: refetchWigets,
    } = useFetch("/configurations/widget", "widgetConfigurations", { tenant: tenant }, null, null, query.middlewareURL);

    const {
        data: addOrEditWidgets,
        isFetching: addOrEditWidgetsIsFetching,
        error: addOrEditWidgetsError,
        isSuccess: addOrEditWidgetsIsSuccess,
        isError: addOrEditWidgetsIsError
    } = useFetch("/configurations/widget", "saveOrEditWidgetConfigs", bodyToPost, isTofecth, 'POST', query.middlewareURL);

    const {
        data: deleted,
    } = useFetch("/configurations/widget", "deleteMetricConfig", { id: idToDelete }, isToFetchDelete, "DELETE", query.middlewareURL);

    useEffect(() => {
        setIsToFetchDelete(false)
    }, [deleted])

    useEffect(() => {
        if (addOrEditWidgetsIsError) {
            const errorMessage = addOrEditWidgetsError?.response?.data?.detailedMessage || t('An error occurred while saving the metric.');

            // Usar uma notificação para exibir o erro
            notification.error({
                message: t('Error'),
                description: t(errorMessage),
                duration: 3,  // Define a duração da notificação (3 segundos)
            });
        } else if (addOrEditWidgets && !addOrEditWidgetsIsFetching && addOrEditWidgetsIsSuccess) {
            setSelectedRecord(null);
        }
        setIsToFetch(false);
    }, [addOrEditWidgetsIsFetching, addOrEditWidgetsIsError]);

    const [modeStartTime, setModeStartTime] = useState("absolute");
    const [modeEndTime, setModeEndTime] = useState("absolute");
    const [startTimeVal, setStartTimeVal] = useState(null);
    const [endTimeVal, setEndTimeVal] = useState(null);

    const handleStartModeChange = (mode) => {
        setModeStartTime(mode)
        setStartTimeVal(null)
    }

    const handleEndModeChange = (mode) => {
        setModeEndTime(mode)
        setEndTimeVal(null)
    }

    const cronRegex = /^([0-5]?[0-9]|\*) ([01]?[0-9]|2[0-3]|\*) (([1-9]|[12][0-9]|3[01]|\?|L|W|\*)) ((1[0-2]|0?[1-9]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC|\*)) (([1-7]|SUN|MON|TUE|WED|THU|FRI|SAT|\?|L|#|\*)) ([0-9]{4}|20[0-9]{2}|\*)$/;
    const [selectedItems, setSelectedItems] = useState([]);
    useEffect(() => {
        if (selectedItems.length > 0) {
            let join = selectedItems.join(",");
            if (join.length > 0) {
                console.log(buildingType)
                console.log(fetchClasses)
                setBuildingType(join)
                setFetchClasses(true)
            }
        }
    }, [selectedItems])

    const CheckboxTagSelect = ({ form, options }) => {

        // Custom tag render for selected items
        const tagRender = (props) => {
            const { label, value, closable, onClose } = props;
            const renderPlaceholder = selectedItems[0].label === label;
            return (
                <>
                    {renderPlaceholder ? <p style={{ margin: '0 5px', fontSize: 'x-small', color: 'grey' }}>{t("Select Items")}</p> : null}
                    <Tag
                        // color="blue"
                        closable={closable}
                        onClose={onClose}
                        style={{ margin: 2 }}
                    >
                        {t(label)}
                    </Tag>
                </>
            );
        };

        // Custom dropdown with checkboxes
        const dropRender = (menu) => (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 8px 0px 8px' }}>
                    <Checkbox
                        indeterminate={selectedItems?.length > 0 && selectedItems?.length < 3}
                        onChange={(e) => { setSelectedItems(e.target.checked ? options.map(x => { return x.value }) : []); form.setFieldsValue({ buildingType: selectedItems.join(',') }) }}
                        checked={selectedItems?.length == options?.length}
                    >
                        {t('All')}
                    </Checkbox>
                    <a
                        onClick={() => { setSelectedItems([]); form.setFieldsValue({ buildingType: selectedItems.join(',') }) }}
                        style={{ float: 'right', padding: '5px 8px', fontSize: 'x-small' }}>
                        {t('Clear Options')}
                    </a>
                </div>
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ padding: '8px', display: 'flex', flexDirection: 'column', maxHeight: '200px', overflowY: 'auto' }}>
                    {options.map((option) => {
                        return (
                            <Checkbox
                                key={option.value}
                                value={option.value}
                                checked={selectedItems.includes(option.value)}
                                onChange={() => {
                                    const newSelectedItems = selectedItems.includes(option.value)
                                        ? selectedItems.filter((item) => item !== option.value)
                                        : [...selectedItems, option.value];
                                    setSelectedItems(newSelectedItems);
                                    form.setFieldsValue({ buildingType: newSelectedItems.join(',') })
                                }}
                                style={{ padding: '5px 0px' }}
                            >
                                {t(option.label)}
                            </Checkbox>
                        )
                    })}
                </div>
            </div>
        );

        return (
            <Select
                bordered={false}
                mode="multiple"
                style={{ width: '100%' }}
                placeholder={< span style={{ color: "lightgrey" }}> {t("Select Items")}</span >}
                value={selectedItems}
                onChange={setSelectedItems}
                dropdownRender={dropRender}
                tagRender={tagRender}
            >
                {
                    options.map((option) => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))
                }
            </Select >
        );
    };

    let tableConfigurations = [
        {
            title: t('Tenant'),
            dataIndex: 'tenant',
            fieldTypeId: 3, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/graph/items?tenant=<TOP_LEVEL_CLIENT_TENANT>
            description: t("Indicates the  the section of the infrastructure that will be used to create the widget."),
        },
        {
            title: t('Widget Type'),
            dataIndex: 'widgetType',
            fieldTypeId: 3, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/widgets/automation/types
            description: t("Indicates the type of widget that will be generated. Each processes data in a unique way."),
        },
        {
            title: t('Scheduler'),
            dataIndex: 'scheduler',
            description: t("String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC)."),
            required: true,
            validateRule: (_, value, setFieldStatus) => {
                if (!cronRegex.test(value)) {
                    setFieldStatus({
                        validateStatus: 'error',
                        help: t('Invalid cron format.'),
                    });
                    return Promise.reject(new Error(t('Invalid cron format.')));
                }

                const [minute, hour, dayOfMonth, month, dayOfWeek, year] = value.split(" ");

                if ((dayOfMonth === "*" && dayOfWeek === "*") || (dayOfMonth === "*" && dayOfWeek !== "?") || (dayOfWeek === "*" && dayOfMonth !== "?")) {
                    setFieldStatus({
                        validateStatus: 'error',
                        help: 'Invalid correlation: if one of Day-of-month or Day-of-week is "*", the other must be "?".',
                    });
                    return Promise.reject(new Error('Invalid correlation: if one of Day-of-month or Day-of-week is "*", the other must be "?".'));
                }
                setFieldStatus({
                    validateStatus: 'success',
                    help: <span style={{ color: 'limegreen' }}>Valid Cron</span>,
                });
                return Promise.resolve();
            }
        },
        {
            title: t('Source Periodicity'),
            dataIndex: 'periodicity',
            fieldTypeId: 6, // DAILY, HOURLY, MONTHLY
            description: t("This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly. This means the working data will be the data aggregated in the specified period."),
            customObject: (form) => {
                return (
                    <Select
                        listHeight={200}
                        size={'large'}
                        bordered={false}
                        options={returnOptions('periodicity', configs)}
                        placeholder={< span style={{ color: "lightgrey" }}> {t("Select Value")}</span >}
                        onChange={(e, record) => {
                            setSelectedPeriodicity(e);
                            form.setFieldsValue({ period: null })
                        }}
                        className={clsx('select-atomic', props?.className, 'full-width')} />
                )
            }
        },
        {
            title: t('Metric'),
            dataIndex: 'metric',
            fieldTypeId: 4, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/metrics/labels
            description: t("Shows all the metrics avaible to construct the data set."),
        },
        {
            title: t('Start Time'),
            dataIndex: 'startTime',
            fieldTypeId: 6,
            description: t("Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)"),
            customObject: (form) => {
                return (
                    <>
                        <Segmented
                            options={[{ label: t("Absolute"), value: "Absolute" }, { label: t("Relative"), value: "Relative" }, { label: t("Last"), value: "Last" }]}
                            onChange={(value) => handleStartModeChange(value.toLowerCase())}
                            block
                        />
                        {modeStartTime == 'absolute' ? (
                            <DatePicker
                                style={{ marginTop: "1%", display: "flex" }}
                                placeholder={t('Select Date')}
                                bordered={false}
                                onChange={(date, dateString) => {
                                    // field.value = new Date(dateString).valueOf();
                                    setStartTimeVal(date.toDate().toString())
                                    form.setFieldsValue({ startTime: date.toDate().toString() })
                                }}
                                // defaultValue={field.value}
                                showTime={{
                                    format: 'HH:mm:ss',
                                }}
                            />
                        ) : modeStartTime == 'relative' ? (
                            <Input
                                style={{ marginTop: "1%", display: "flex" }}
                                type="text"
                                bordered={false}
                                placeholder={t("Enter number and (day or hour)")}
                                onChange={(e) => {
                                    const finalRegex = /^(\d{1,3}) (hour|hora|day|dia)$/
                                    let date = ""
                                    if (finalRegex.test(e.target.value.toLocaleLowerCase())) {
                                        // field.value = e.target.value.toLocaleLowerCase()
                                        const matches = e.target.value.match(finalRegex);
                                        var attr = i18n.getFixedT('en')(matches[matches.length - 1]).toLocaleLowerCase();
                                        // field.value = dayjs().subtract(matches[matches.length - 2], attr).toDate().toString()
                                        date = dayjs().subtract(matches[matches.length - 2], attr).toDate().toString()
                                    }
                                    form.setFieldsValue({ startTime: date })
                                    setStartTimeVal(date)
                                }}
                            />
                        )
                            : (
                                <Input
                                    style={{ marginTop: "1%", display: "flex" }}
                                    type="text"
                                    bordered={false}
                                    placeholder={t("Enter number and (day, month or year)")}
                                    onChange={(e) => {
                                        const finalRegex = /^(\d{1,3}) (ano|mes|mês|dia|day|month|year)$/
                                        let date = ""
                                        if (finalRegex.test(e.target.value.toLocaleLowerCase())) {
                                            // field.value = e.target.value.toLocaleLowerCase()
                                            const matches = e.target.value.match(finalRegex);
                                            var attr = i18n.getFixedT('en')(matches[matches.length - 1]).toLocaleLowerCase();
                                            date = dayjs().subtract(matches[matches.length - 2], i18n.getFixedT('en')(attr))
                                                .hour(0).minute(0).second(0).millisecond(0).toDate().toString()
                                        }
                                        form.setFieldsValue({ startTime: date.toDate().toString() })
                                        setStartTimeVal(date)
                                    }}
                                />
                            )
                        }
                        {startTimeVal}
                    </>
                )
            }
        },
        {
            title: t('End Time'),
            dataIndex: 'endTime',
            description: t("Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)"),
            fieldTypeId: 6,
            customObject: (form) => {
                return (
                    <>
                        <Segmented
                            options={[{ label: t("Absolute"), value: "Absolute" }, { label: t("Relative"), value: "Relative" }, { label: t("Last"), value: "Last" }]}
                            onChange={(value) => { form.setFieldsValue({ endTime: '' }); handleEndModeChange(value.toLowerCase()) }}
                            block
                        />
                        {modeEndTime == 'absolute' ? (
                            <DatePicker
                                style={{ marginTop: "1%", display: "flex" }}
                                bordered={false}
                                placeholder={t('Select Date')}
                                onChange={(date, dateString) => {
                                    setEndTimeVal(date.toDate().toString())
                                    form.setFieldsValue({ endTime: date.toDate().toString() })
                                }}
                                // defaultValue={field.value}
                                showTime={{
                                    format: 'HH:mm:ss',
                                }}
                            />
                        ) : modeEndTime == 'relative' ? (
                            <Input
                                style={{ marginTop: "1%", display: "flex" }}
                                type="text"
                                bordered={false}
                                placeholder={t("Enter number and (day or hour)")}
                                onChange={(e) => {
                                    const finalRegex = /^(\d{1,3}) (hour|hora|day|dia)$/
                                    let date = ""
                                    if (finalRegex.test(e.target.value.toLocaleLowerCase())) {
                                        // field.value = e.target.value.toLocaleLowerCase()
                                        const matches = e.target.value.match(finalRegex);
                                        var attr = i18n.getFixedT('en')(matches[matches.length - 1]).toLocaleLowerCase();
                                        // field.value = dayjs().subtract(matches[matches.length - 2], attr).toDate().toString()
                                        date = dayjs().subtract(matches[matches.length - 2], attr).toDate().toString()
                                    }
                                    setEndTimeVal(date)
                                    form.setFieldsValue({ endTime: date })
                                }}
                            />
                        )
                            : (
                                <Input
                                    style={{ marginTop: "1%", display: "flex" }}
                                    type="text"
                                    bordered={false}
                                    placeholder={t("Enter number and (day, month or year)")}
                                    onChange={(e) => {
                                        const finalRegex = /^(\d{1,3}) (ano|mes|mês|dia|day|month|year)$/
                                        let date = ""
                                        if (finalRegex.test(e.target.value.toLocaleLowerCase())) {
                                            // field.value = e.target.value.toLocaleLowerCase()
                                            const matches = e.target.value.match(finalRegex);
                                            var attr = i18n.getFixedT('en')(matches[matches.length - 1]).toLocaleLowerCase();
                                            date = dayjs().subtract(matches[matches.length - 2], i18n.getFixedT('en')(attr))
                                                .hour(0).minute(0).second(0).millisecond(0).toDate().toString()
                                        }
                                        setEndTimeVal(date)
                                        form.setFieldsValue({ endTime: date })
                                    }}
                                />
                            )
                        }
                        {endTimeVal}
                    </>
                )
            }
        },
        {
            title: t('Transformation'),
            dataIndex: 'transformation',
            fieldTypeId: 3, //  https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/metrics/operations
            description: t("The first field indicates which transformation to apply to the result from the available options. The second field is a valid mathematical expression that will be applied to the result after the transformation."),
        },
        {
            title: t('Registry'),
            dataIndex: 'registry',
            fieldTypeId: 1,
            size: 3
        },
        {
            title: t('Type'),
            dataIndex: 'buildingType',
            fieldTypeId: 6, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/graph/items/distinct-properties?tenant=<>&property=type
            child: true,
            description: t("Represents the type of infrastructure available, such as Buildings or Infrastructure."),
            customObject: (form) => {
                return (
                    <CheckboxTagSelect form={form} options={returnOptions('buildingType', configs)} />
                )
            },
            size: 7
        },
        {
            title: t('Class'),
            dataIndex: 'buildingClass',
            fieldTypeId: 6, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/graph/items/distinct-properties?tenant=%3c%3e&property=class&type=%3c%3e&type=...
            child: true,
            description: t("Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces."),
            customObject: () => {
                return (
                    <MultipleSelectAtomic optionsData={selectedItems.length > 0 ? buildingInformation?.result?.map(x => ({ label: x, value: x })) : []}
                        disabled={selectedItems.length != 0 && buildingInformation ? false : true}
                        placeholder={t("Select Value")}
                        defaultValue={[]}
                        fullWidth={true} isModal={true} allAvailable={true} />
                )
            },
            size: 7
        },

        {
            title: t('Detail By Name'),
            dataIndex: 'detailSeperation',
            fieldTypeId: 3, // TRUE OR FALSE
            child: true,
            description: t("Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually."),
            size: 7,
        },

        {
            title: t('Top'),
            dataIndex: 'top',
            fieldTypeId: 1,
            size: 3,
        },
        {
            title: t('Type Number'),
            dataIndex: 'typeNumber',
            child: true,
            description: t("The field box represents the top N from the Type category."),
            size: 7,
        },
        {
            title: t('Class Number'),
            dataIndex: 'classNumber',
            child: true,
            description: t("The second box represents the top N from the Class category."),
            size: 7,
        },
        {
            title: t('Detail Number'),
            dataIndex: 'detailNumber',
            child: true,
            description: t("The third box represents the top N from the Name category."),
            size: 7,
        },
        // {
        //     title: t('History'),
        //     dataIndex: 'history',
        //     fieldTypeId: 3, // TRUE OR FALSE
        //     description: t("This field indicates whether the result of the widget will include historical data. If set to True, the datasets will vary according to the specified time period."),
        // },
        {
            title: t('Data Aggregation'),
            dataIndex: 'aggregation',
            description: t("This setup indicates how to divide the dataset according to the specified period. These selections do not affect the transformation input. The first field represents a quantifying number, and the second field specifies whether that number is in hours, days, or months."),
            size: 12,
        },
        {
            title: t('Period'),
            dataIndex: 'period',
            fieldTypeId: 6, // HOUR, DAY, MONTH
            customObject: () => {
                return (
                    <Select
                        listHeight={200}
                        size={'large'}
                        bordered={false}
                        placeholder={< span style={{ color: "lightgrey" }}> {t("Select Value")}</span >}
                        options={returnOptions('period', configs, selectedPeriodicity)}
                        className={clsx('select-atomic', props?.className, 'full-width')} />
                )
            },
            size: 12
        },
        {
            title: t('Widget Dataset Name'),
            dataIndex: 'widgetDatasetName',
            description: t("An identified name for the widget"),
        },
        {
            title: t('Privacy'),
            dataIndex: 'privacy',
            fieldTypeId: 3,
            description: t("Public or Private"),
        },
        {
            title: t('Description'),
            dataIndex: 'description',
            fieldTypeId: 7,
            description: t("A Description for the widget"),
        },
    ]

    function handleOkModal(data) {
        const copyData = {
            Tenant: data?.tenant,
            Widget_Type: data?.widgetType,
            Scheduler: data?.scheduler,
            Registry: data?.buildingType + ";" + data?.buildingClass.map(_ => _.value).join(',') + ";" + data?.detailSeperation,
            TOP: data?.typeNumber + ";" + data?.classNumber + ";" + data?.detailNumber,
            "Start Time": startTimeVal ?? data?.startTime,
            "End Time": endTimeVal ?? data?.endTime,
            Metrics: data?.metric.map(_ => _.value).join(','),
            Periodicity: data?.periodicity,
            // History: data?.history,
            Division: data?.aggregation + " " + data?.period,
            Transformation: data?.transformation,
            Type: "Pre-Processed",
            Widget_Dataset_Name: data?.widgetDatasetName,
            Privacy: data?.privacy,
            Description: t(data?.description),
        };
        setBodyToPost(copyData);
        setIsToFetch(true);
        setModeStartTime("absolute");
        setModeEndTime("absolute");
        setIsModalOpen(false);
        setSelectedRecord(null);
        refetchWigets();
    }

    function handleCloseModal() {
        setModeStartTime("absolute");
        setModeEndTime("absolute");
        setStartTimeVal(null)
        setEndTimeVal(null)
        setIsModalOpen(false);  // Fecha a modal
        setSelectedRecord(null); // Limpa o registro selecionado
    }

    return (
        <PageContent className={clsx('building_room_details', props?.className)}>
            <PageSection>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Row gutter={[16, 16]}>
                            <Col span={4}>
                                <PageTitle>
                                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium' $marginRight='s03'>{t('Widget List')}</Text>
                                </PageTitle>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        {
                            widgets && configs ?
                                <ComplexTable fetchData={serealizeData(widgets, t)} language={i18next.resolvedLanguage}
                                    tableConfiguration={{ collumnsConfiguration: tableConfigurations }}
                                    deleteButton={allowedToWrite}
                                    fixedActions={true}
                                    handleDelete={(record) => { setIdToDelete(record.id); setIsToFetchDelete(true); }}
                                    pagination={{ pageSize: 5 }}
                                    customizedButtons={
                                        getCustomizedButtonsForConfiguration(widgets && configs && allowedToWrite,
                                            () => { setSelectedRecord(emptyRecord); setIsModalOpen(true) }, t)
                                    }
                                />
                                :
                                <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Spinner stroke="green" />
                                </div>
                        }
                    </Col>
                    <EditPopupConfigurations
                        openModal={isModalOpen}
                        closeModal={handleCloseModal}
                        onOkModal={(data) => handleOkModal(data)}
                        selectedRecord={selectedRecord ? serealizeRecordForModal(selectedRecord, configs, tableConfigurations, selectedPeriodicity) : null}
                        customWidth={800} />
                </Row>
            </PageSection>
        </PageContent>
    )
}

//Serializer para tornar a modal no formato correto para editar um User, como uma configuração para a Modal
const serealizeRecordForModal = (selectedRecord, configValues, tableRes, selectedPeriodicity) => {
    // const keysToKeep = ['username', 'email', 'phone_number', 'tenant', 'zones', 'tags'];
    const keysToKeep = tableRes.flatMap(x => {
        if (x.subfields) {
            return [...x.subfields.map(y => y.dataIndex), x.dataIndex];
        } else {
            return x.dataIndex
        }
    });
    const result = tableRes.flatMap(x => {
        var obj = Object.entries(selectedRecord);
        if (x.subfields) {
            var foundObj = obj.find(z => z[0] === x.dataIndex);
            var parentObj = buildObj(foundObj, x, null, true, returnOptions, configValues, selectedPeriodicity);
            return [({
                childs: x.subfields.map(y => {
                    var foundObj = obj.find(z => z[0] === y.dataIndex);
                    return buildObj(foundObj, y, true, parentObj.key, returnOptions, configValues, selectedPeriodicity);
                }), parent: parentObj
            })];
        } else {
            var foundObj = obj.find(z => z[0] === x.dataIndex);
            return buildObj(foundObj, x, null, null, returnOptions, configValues, selectedPeriodicity);
        }
    })

    var y = result.filter(x => {
        if (x.parent) {
            for (var i = 0; i < x.childs.length; i++) {
                if (!keysToKeep.includes(x.childs[i].key))
                    delete x.childs[i]
            }
            return keysToKeep.includes(x.parent.key)
        }
        return keysToKeep.includes(x.key)
    });
    return y;
};

const emptyRecord = {
    "id": null,
    "tenant": null,
    "widgetType": null,
    "scheduler": null,
    "registry": null,
    "buildingType": null,
    "buildingClass": null,
    "detailSeperation": null,
    "top": null,
    "typeNumber": null,
    "classNumber": null,
    "detailNumber": null,
    "startTime": null,
    "endTime": null,
    "metric": null,
    "periodicity": null,
    // "history": null,
    "aggregation": null,
    "period": null,
    "transformation": null,
    "widgetDatasetName": null,
    "privacy": null,
    "description": null,
}

const allowedPeriods = {
    'HOURLY': ['HOUR', 'DAY', 'MONTH'],
    'DAILY': ['DAY', 'MONTH'],
    'MONTHLY': ['MONTH'],
};

const serealizeData = (values, t) => {
    return values.map(e => {
        var jsonOBJ = JSON.parse(e['Widget_Propierties']?.S);
        return {
            id: e["Widget_ID"]?.S,
            tenant: e["Tenant"]?.S,
            widgetType: e["Widget_Type"]?.S,
            scheduler: e["Scheduler"]?.S,
            registry: jsonOBJ['Registry'],
            buildingType: jsonOBJ['Registry']?.split(';')[0],
            buildingClass: jsonOBJ['Registry']?.split(';')[1],
            detailSeperation: jsonOBJ['Registry']?.split(';')[2],

            top: jsonOBJ["TOP"],
            typeNumber: jsonOBJ["TOP"]?.split(';')[0],
            classNumber: jsonOBJ["TOP"]?.split(';')[1],
            detailNumber: jsonOBJ["TOP"]?.split(';')[2],
            startTime: convertDate(jsonOBJ["Start Time"], t),
            endTime: convertDate(jsonOBJ["End Time"], t),
            metric: jsonOBJ["Metrics"],
            periodicity: jsonOBJ["Periodicity"],
            // history: jsonOBJ["History"],

            aggregation: jsonOBJ['Division']?.split(' ')[0],
            period: jsonOBJ['Division']?.split(' ')[1],
            transformation: jsonOBJ["Transformation"],
            widgetDatasetName: e['Widget_Dataset_Name']?.S,
            privacy: e['Privacy']?.S,
            description: e['Description']?.S,
        }
    });
}

function convertDate(value, t) {
    if (!isNaN(value)) {
        return new Date(Number(value) * 1000).toUTCString()
    }
    if (value == 'present')
        return new Date().toUTCString()
    return new Date(value) == t('Invalid Date') ? '' : new Date(value).toUTCString()
}

function returnOptions(key, configValues, selectedPeriodicity) {
    if (configValues) {
        switch (key) {
            case 'tenant':
                return configValues[key].result.map(x => { return { label: x.tenant, value: x.tenant } });
            case 'periodicity':
                return periodicity.map(x => { return { lable: x, value: x } });
            case 'privacy':
                return privacy.map(x => { return { lable: x, value: x } });
            case 'period':
                let allowed = allowedPeriods[selectedPeriodicity?.toUpperCase()] || [];
                return period.filter(p => allowed.includes(p.toUpperCase())).map(z => { return { lable: z, value: z } });
            case 'detailSeperation':
                // case 'history':
                return booleans.map(x => { return { label: x, value: x } });
            case 'widgetType':
                return configValues[key].map(x => { return { label: x['Widget_Type'].S, value: x['Widget_Type'].S } })
            default:
                if (configValues[key]) {
                    if (configValues[key].result) {
                        let x = uniqueObjectsByProperty(configValues[key].result.map(x => { return { label: x, value: x } }), "label");
                        return x;
                    } else if (Array.isArray(configValues[key])) {
                        let x = uniqueObjectsByProperty(configValues[key]);
                        return x;
                    }
                }
                else
                    return [];
        }
    }
}

function uniqueObjectsByProperty(array, property) {
    if (property)
        return Array.from(new Set(array.map(item => item[property]))).map(value => ({ label: value, value: value }));
    else
        return Array.from(new Set(array)).map(value => ({ label: value, value: value }));
}